
<div class="rightPannelBox disruptedTab closebtn">

  <div class="fltpanIn">
    <div class="row mb-10">
      <div class="col-lg-9">
        <h2>Disrupted Order Viewer</h2>
      </div>
      <div class="text-right col-lg-3">
        <!-- <button type="button" (click)="refreshList()" role="button" class="ba-btn ba-btn-sq-sm"><i
            class="fas fa-sync"></i> Refresh</button> -->
        &nbsp;&nbsp;
        <button (click)="disruptScreenCloseClick()" class="ba-btn ba-btn-sq-sm" role="button"><i class="fa fa-times"></i></button>
      </div>
      <!-- error section-->
      <div class="col-lg-1"></div>
      <div id="errorpn-register" class="col-lg-10" *ngIf="ocnMessageError">
        <div id="errDet" class="err-register">
          {{ ocnMessageError }}
        </div>
      </div>
      <div class="col-lg-1"></div>
      <!--error section end-->
    </div>
    <div class="row">
      <div class="col-lg-6 mt-4 mb-3">
        <div class="disruptStatus nav nav-tabs row" id="myTab">

          <div data-bs-toggle="tab" href="#Pending" class="col-lg-3 me-2 nav-item nav-link active"
            (click)="loadTAB('PENDING')">Pending</div>
          <div data-bs-toggle="tab" href="#Actioned" class="col-lg-3 nav-item nav-link" (click)="loadTAB('ACTIONED')">
            Actioned</div>
          <div data-bs-toggle="tab" href="#Archives" class="col-lg-3 nav-item nav-link" (click)="loadTAB('ARCHIVE')">
            Archives</div>
        </div>
      </div>
      <div class="col-lg-6 mt-4 mb-3 ">
        <form class="text-right me-3" [formGroup]="searchForm" (submit)="searchPNR()">

          <div class="row">
            <div class="col-lg-3 no-pad-l p-r-5">
              <input formControlName="fromDate" type="date" class="form-control" />
            </div>
            <div class="col-lg-3 no-pad-l p-r-5">
              <input formControlName="toDate" [min]="minToDate" [max]="maxToDate" type="date" class="form-control" />
            </div>
            <div class=" no-pad-l p-r-5 d-i-flex right-head">
              <input placeholder="Search..." type="text" minlength="6" maxlength="6" (keyup)="findPNR()" class="search"
                formControlName="pnr">
            </div>
            <div class=" no-pad-l p-r-5 text-left right-head">
              <button *ngIf="!isEnableSearch" disabled class="serachBtn">Search</button>
              <button *ngIf="isEnableSearch" class="serachBtn">Search</button>
            </div>
            <div class="no-pad-l p-r-5 right-head">
              <button type="button" class="serachBtn" (click)="resetFilter()">Reset</button>
            </div>
          </div>
        </form>
      </div>
      <div id="myTabContent" class="col-sm-12 tab-content">
        <div class="tab-pane fade show active" id="Pending">
          <ng-template [ngIf]="ocnMessageScreen.sortPendingPnrDetails && ocnMessageScreen.sortPendingPnrDetails.length > 0">
            <div class="flexAside peginationBar">
              <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item">
                    <button [disabled]="pendingOcnMessagePaginationSettings.activePageIndex === 0" class="page-link" href="#" aria-label="Previous" (click)="triggerPendingRender('minus')">
                      <span aria-hidden="true">&laquo;</span>
                    </button>
                  </li>

                  <li
                    class="page-item"
                    [class.active]="buttonDetail.isActive === 'Yes'"
                    *ngFor="let buttonDetail of pendingOcnMessagePaginationSettings.buttonList"
                    (click)="updatePendingOcnMessagePagination(buttonDetail.index)"
                  >
                    <ng-template [ngIf]="buttonDetail.isActive === 'Yes'">
                      <span class="page-link">{{ buttonDetail.text }}</span>
                    </ng-template>
                    <ng-template [ngIf]="buttonDetail.isActive === 'No'">
                      <a class="page-link" href="#">{{ buttonDetail.text }}</a>
                    </ng-template>
                  </li>

                  <li class="page-item">
                    <button
                      [disabled]="pendingOcnMessagePaginationSettings.activePageIndex === pendingOcnMessagePaginationSettings.maxPageIndex"
                      class="page-link"
                      href="#"
                      aria-label="Next"
                      (click)="triggerPendingRender('plus')"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>

              <div class="pegiCount ms-3">
                <select (change)="updatePendingPaginationLength()"
                  [(ngModel)]="pendingOcnMessagePaginationSettings.activeLength">
                  <option *ngFor="let len of pendingOcnMessagePaginationSettings.lengthMenu"
                    [selected]="len.Label === pendingOcnMessagePaginationSettings.activeLength" value="{{len.Label}}">
                    {{len.Value}}</option>

                </select>
              </div>
            </div>
          </ng-template>
          <div class="col-sm-12 disruptedTable">
            <div class="row grayTitle">
              <div class="col-lg-2">PNR</div>
              <!-- Need to fix as part of Move to Archive -->
              <!-- <div class="col-lg-1">
                <input type="checkbox" class="checkme" name="checkbox" [(ngModel)]="masterSelected"
                  (change)="checkUncheckAll()" value="checkbox">
                <span class="all">All</span>
              </div> -->
              <div class="col-lg-6">Disrupted Flight</div>
              <div class="col-lg-1">IATA</div>
              <div class="col-lg-2 text-right"></div>
            </div>
            <ng-template [ngIf]="reqBody.length > 0">
              <div class="row">
                <div class="col-sm-10 m-1">
                  <!-- Button trigger modal -->

                  <!-- Need to fix as part of Move to Archive -->
                  <!-- <button type="button" class="btn btn-primary" (click)="movetoArchived()" data-bs-toggle="modal" data-bs-target="#ocnModal">

                    Move To Archive
                  </button>-->

                </div>
              </div>
            </ng-template>
            <div class="row disruptedTableData" *ngFor="let item of ocnMessageScreen.sortPendingPnrDetails; let i=index"
              [style.background-color]="item.isSelected? '#a3cbf5' : 'white'"
              [style.color]="item.isSelected? 'gray' : 'black'">
              <div class="col-lg-2 cell" *ngIf="(item.status==='PENDING' && pending)"><a (click)="viewXML(i)">
                  {{item.pnr}}</a></div>
              <!-- Need to fix as part of Move to Archive -->
              <!-- <div class="col-lg-1"><input type="checkbox" name="checkbox" [(ngModel)]="item.isSelected"
                  (change)="slectPNRDetail()"></div> -->
              <div class="col-lg-6 cell" *ngIf="(item.status==='PENDING' && pending)">
                <div class="">
                  <div class="row">
                    <div class="flexContent">
                      <ng-template class="" [ngIf]="item.cancelledFlightSegment && item.cancelledFlightSegment.length > 0">
                        <div class="inner pink">

                          <div class="item-seperator"
                            *ngFor="let cancelledFlightSegment of item.cancelledFlightSegment">
                            <div class="row ms-0 me-0">
                              <strong>{{cancelledFlightSegment.MarketingCarrier.AirlineID}}{{cancelledFlightSegment.MarketingCarrier.FlightNumber}}</strong>

                              <span class="seperator">|</span> CANCELLED
                            </div>
                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{cancelledFlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{cancelledFlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{cancelledFlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ cancelledFlightSegment.Departure.AirportCode }}</div>
                              <div>{{ cancelledFlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template class="" [ngIf]="item.cancelledFlightSegment.length === 0">
                        <div class="inner gray" *ngIf="item.scheduledFlightSegment.length === 0">
                          <div class="item-seperator" *ngFor="let FlightSegment of item.FlightSegmentList">

                            <div class="row ms-0 me-0">
                              <strong>{{FlightSegment.MarketingCarrier.AirlineID}}{{FlightSegment.MarketingCarrier.FlightNumber}}</strong>
                            </div>

                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{FlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{FlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{FlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ FlightSegment.Departure.AirportCode }}</div>
                              <div>{{ FlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="inner gray" *ngIf="item.scheduledFlightSegment.length > 0">

                          <div class="row ms-0 me-0">
                            N/A </div>

                        </div>
                      </ng-template>

                      <ng-template [ngIf]="item.scheduledFlightSegment && item.scheduledFlightSegment.length > 0">
                        <div class="inner green">

                          <div class="item-seperator"
                            *ngFor="let scheduledFlightSegment of item.scheduledFlightSegment">
                            <div class="row ms-0 me-0">
                              <strong>{{scheduledFlightSegment.MarketingCarrier.AirlineID}}{{scheduledFlightSegment.MarketingCarrier.FlightNumber}}</strong>


                              <span class="seperator">|</span><span *ngIf="item.UNDate !== scheduledFlightSegment.Departure.Date">SCHEDULE CHANGE</span>
                              <span *ngIf="item.UNDate === scheduledFlightSegment.Departure.Date">TIME CHANGE</span>
                            </div>


                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{scheduledFlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{scheduledFlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{scheduledFlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ scheduledFlightSegment.Departure.AirportCode }}</div>
                              <div>{{ scheduledFlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>

                      <ng-template class="" [ngIf]="item.scheduledFlightSegment.length === 0">
                        <div class="inner gray">

                          <div class="row ms-0 me-0">
                            N/A </div>

                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-1 cell" *ngIf="item.status === 'PENDING' && pending">{{ item.iataNumber }}</div>




              <div class="col-lg-2 cell text-center actions" *ngIf="(item.status==='PENDING' && pending)">
                <i class="fa fa-edit me-4" (click)="getSelectedPnrDetails('PENDING',i)"></i>

                <!-- <i class="fa fa-trash"></i> -->
                <i class="fa fa-download me-4" (click)="downloadXML(i)"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="Actioned">
          <ng-template [ngIf]="ocnMessageScreen.sortActionedPnrDetails && ocnMessageScreen.sortActionedPnrDetails.length > 0">
            <div class="flexAside peginationBar">
              <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item">
                    <button [disabled]="actionedOcnMessagePaginationSettings.activePageIndex === 0" (click)="triggerActionedRender('minus')" class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </button>
                  </li>
                  <li
                    class="page-item"
                    [class.active]="buttonDetail.isActive === 'Yes'"
                    *ngFor="let buttonDetail of actionedOcnMessagePaginationSettings.buttonList"
                    (click)="updateActionedOcnMessagePagination(buttonDetail.index)"
                  >
                    <ng-template [ngIf]="buttonDetail.isActive === 'Yes'">
                      <span class="page-link">{{ buttonDetail.text }}</span>
                    </ng-template>
                    <ng-template [ngIf]="buttonDetail.isActive === 'No'">
                      <a class="page-link" href="#">{{ buttonDetail.text }}</a>
                    </ng-template>
                  </li>
                  <li class="page-item">
                    <button
                      [disabled]="actionedOcnMessagePaginationSettings.activePageIndex === actionedOcnMessagePaginationSettings.maxPageIndex"
                      (click)="triggerActionedRender('plus')"
                      class="page-link"
                      href="#"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>

              <div class="pegiCount ms-3">
                <select (change)="updateActionedPaginationLength()"
                  [(ngModel)]="actionedOcnMessagePaginationSettings.activeLength">
                  <option *ngFor="let len of actionedOcnMessagePaginationSettings.lengthMenu"
                    [selected]="len.Label === actionedOcnMessagePaginationSettings.activeLength" value="{{len.Label}}">
                    {{len.Value}}</option>

                </select>
              </div>
            </div>
          </ng-template>
          <div class="col-sm-12 disruptedTable">
            <div class="row grayTitle">
              <div class="col-lg-2">PNR</div>
              <div class="col-lg-6">Disrupted Flight</div>
              <div class="col-lg-1">IATA</div>
              <div class="col-lg-2">User Action</div>
              <div class="col-lg-1"></div>
            </div>
            <div class="row disruptedTableData" *ngFor="let item of ocnMessageScreen.sortActionedPnrDetails; let i = index">
              <div class="col-lg-2 cell" *ngIf="(item.status === 'ACTIONED' || item.status === 'CANCELLED') && actioned">
                <a (click)="viewXML(i)"> {{ item.pnr }}</a>
              </div>
              <div class="col-lg-6 cell" *ngIf="(item.status === 'ACTIONED' || item.status === 'CANCELLED') && actioned">
                <div class="">
                  <div class="row">
                    <div class="flexContent">
                      <ng-template class="" [ngIf]="item.cancelledFlightSegment && item.cancelledFlightSegment.length > 0">
                        <div class="inner pink">

                          <div class="item-seperator"
                            *ngFor="let cancelledFlightSegment of item.cancelledFlightSegment">
                            <div class="row ms-0 me-0">
                              <strong>{{cancelledFlightSegment.MarketingCarrier.AirlineID}}{{cancelledFlightSegment.MarketingCarrier.FlightNumber}}</strong>

                              <span class="seperator">|</span> CANCELLED
                            </div>
                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{cancelledFlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{cancelledFlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{cancelledFlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ cancelledFlightSegment.Departure.AirportCode }}</div>
                              <div>{{ cancelledFlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>

                      <ng-template class="" [ngIf]="item.cancelledFlightSegment.length === 0">
                        <div class="inner gray" *ngIf="item.scheduledFlightSegment.length === 0">
                          <div class="item-seperator" *ngFor="let FlightSegment of item.FlightSegmentList">

                            <div class="row ms-0 me-0">
                              <strong>{{FlightSegment.MarketingCarrier.AirlineID}}{{FlightSegment.MarketingCarrier.FlightNumber}}</strong>


                            </div>

                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{FlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{FlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{FlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ FlightSegment.Departure.AirportCode }}</div>
                              <div>{{ FlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="inner gray" *ngIf="item.scheduledFlightSegment.length > 0">

                          <div class="row ms-0 me-0">
                            N/A </div>

                        </div>
                      </ng-template>
                      <ng-template [ngIf]="item.scheduledFlightSegment && item.scheduledFlightSegment.length > 0">
                        <div class="inner green">

                          <div class="item-seperator"
                            *ngFor="let scheduledFlightSegment of item.scheduledFlightSegment">
                            <div class="row ms-0 me-0">
                              <strong>{{scheduledFlightSegment.MarketingCarrier.AirlineID}}{{scheduledFlightSegment.MarketingCarrier.FlightNumber}}</strong>


                              <span class="seperator">|</span><span *ngIf="item.UNDate !== scheduledFlightSegment.Departure.Date">SCHEDULE CHANGE</span>
                              <span *ngIf="item.UNDate === scheduledFlightSegment.Departure.Date">TIME CHANGE</span>
                            </div>


                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{scheduledFlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{scheduledFlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{scheduledFlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ scheduledFlightSegment.Departure.AirportCode }}</div>
                              <div>{{ scheduledFlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>

                      <ng-template class="" [ngIf]="item.scheduledFlightSegment.length === 0">
                        <div class="inner gray">

                          <div class="row ms-0 me-0">
                            N/A </div>

                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-1 cell" *ngIf="(item.status === 'ACTIONED' || item.status === 'CANCELLED') && actioned">{{ item.iataNumber }}</div>
              <div class="col-lg-2 cell">
                {{ item.userAction }}
              </div>
              <div class="col-lg-1 cell actions">
                <i class="fa fa-download me-4" (click)="downloadXML(i)"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="Archives">
          <ng-template [ngIf]="ocnMessageScreen.sortArchivePnrDetails && ocnMessageScreen.sortArchivePnrDetails.length > 0">
            <div class="flexAside peginationBar">
              <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item">
                    <button [disabled]="archiveOcnMessagePaginationSettings.activePageIndex === 0" (click)="triggerArchivedRender('minus')" class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </button>
                  </li>
                  <li
                    class="page-item"
                    [class.active]="buttonDetail.isActive === 'Yes'"
                    *ngFor="let buttonDetail of archiveOcnMessagePaginationSettings.buttonList"
                    (click)="updateArchivedOcnMessagePagination(buttonDetail.index)"
                  >
                    <ng-template [ngIf]="buttonDetail.isActive === 'Yes'">
                      <span class="page-link">{{ buttonDetail.text }}</span>
                    </ng-template>
                    <ng-template [ngIf]="buttonDetail.isActive === 'No'">
                      <a class="page-link" href="#">{{ buttonDetail.text }}</a>
                    </ng-template>
                  </li>
                  <li class="page-item">
                    <button
                      [disabled]="archiveOcnMessagePaginationSettings.activePageIndex === archiveOcnMessagePaginationSettings.maxPageIndex"
                      (click)="triggerArchivedRender('plus')"
                      class="page-link"
                      href="#"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>

              <div class="pegiCount ms-3">
                <select (change)="updateArchivedPaginationLength()"
                  [(ngModel)]="archiveOcnMessagePaginationSettings.activeLength">
                  <option *ngFor="let len of archiveOcnMessagePaginationSettings.lengthMenu"
                    [selected]="len.Label === archiveOcnMessagePaginationSettings.activeLength" value="{{len.Label}}">
                    {{len.Value}}</option>

                </select>
              </div>
            </div>
          </ng-template>
          <div class="col-sm-12 disruptedTable">
            <div class="row grayTitle">
              <div class="col-lg-2">PNR</div>
              <div class="col-lg-6">Disrupted Flight</div>
              <div class="col-lg-1">IATA</div>
              <div class="col-lg-2">User Action</div>
              <div class="col-lg-1"></div>
            </div>
            <div class="row disruptedTableData" *ngFor="let item of ocnMessageScreen.sortArchivePnrDetails; let i = index">
              <div class="col-lg-2 cell" *ngIf="(item.status === 'ACTIONED' || item.status === 'CANCELLED' || item.status === 'PENDING') && archive">
                <a (click)="viewXML(i)">{{ item.pnr }}</a>
              </div>
              <div class="col-lg-6 cell" *ngIf="(item.status === 'ACTIONED' || item.status === 'CANCELLED' || item.status === 'PENDING') && archive">
                <div class="">
                  <div class="row">
                    <div class="flexContent">
                      <ng-template class="" [ngIf]="item.cancelledFlightSegment && item.cancelledFlightSegment.length > 0">
                        <div class="inner pink">

                          <div class="item-seperator"
                            *ngFor="let cancelledFlightSegment of item.cancelledFlightSegment">
                            <div class="row ms-0 me-0">
                              <strong>{{cancelledFlightSegment.MarketingCarrier.AirlineID}}{{cancelledFlightSegment.MarketingCarrier.FlightNumber}}</strong>

                              <span class="seperator">|</span> CANCELLED
                            </div>
                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{cancelledFlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{cancelledFlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{cancelledFlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ cancelledFlightSegment.Departure.AirportCode }}</div>
                              <div>{{ cancelledFlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>

                      <ng-template class="" [ngIf]="item.cancelledFlightSegment.length === 0">
                        <div class="inner gray" *ngIf="item.scheduledFlightSegment.length === 0">
                          <div class="item-seperator" *ngFor="let FlightSegment of item.FlightSegmentList">

                            <div class="row ms-0 me-0">
                              <strong>{{FlightSegment.MarketingCarrier.AirlineID}}{{FlightSegment.MarketingCarrier.FlightNumber}}</strong>


                            </div>

                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{FlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{FlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{FlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ FlightSegment.Departure.AirportCode }}</div>
                              <div>{{ FlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="inner gray" *ngIf="item.scheduledFlightSegment.length > 0">

                          <div class="row ms-0 me-0">
                            N/A </div>

                        </div>
                      </ng-template>
                      <ng-template [ngIf]="item.scheduledFlightSegment && item.scheduledFlightSegment.length > 0">
                        <div class="inner green">

                          <div class="item-seperator"
                            *ngFor="let scheduledFlightSegment of item.scheduledFlightSegment">
                            <div class="row ms-0 me-0">
                              <strong>{{scheduledFlightSegment.MarketingCarrier.AirlineID}}{{scheduledFlightSegment.MarketingCarrier.FlightNumber}}</strong>


                              <span class="seperator">|</span><span *ngIf="item.UNDate !== scheduledFlightSegment.Departure.Date">SCHEDULE CHANGE</span>
                              <span *ngIf="item.UNDate === scheduledFlightSegment.Departure.Date">TIME CHANGE</span>
                            </div>


                            <div class="row ms-0 me-0 innerfirst innerSecond">
                              <div>{{scheduledFlightSegment.Departure.Date | dateFormat: 'dd MMM'}}</div>
                              <div class="timeFont">{{scheduledFlightSegment.Departure.Time}}</div>
                              <div class="timeFont">{{scheduledFlightSegment.Arrival.Time}}</div>

                            </div>
                            <div class="row ms-0 me-0 innerSecond">
                              <div></div>
                              <div>{{ scheduledFlightSegment.Departure.AirportCode }}</div>
                              <div>{{ scheduledFlightSegment.Arrival.AirportCode }}</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>

                      <ng-template class="" [ngIf]="item.scheduledFlightSegment.length === 0">
                        <div class="inner gray">

                          <div class="row ms-0 me-0">
                            N/A </div>

                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-1 cell" *ngIf="(item.status === 'ACTIONED' || item.status === 'CANCELLED' || item.status === 'PENDING') && archive">
                {{ item.iataNumber }}
              </div>
              <div class="col-lg-2 cell">
                {{ item.userAction }}
              </div>
              <div class="col-lg-1 cell actions">
                <i class="fa fa-download me-4" (click)="downloadXML(i)"></i>
              </div>


              <div class="col-lg-2 cell text-right actions" *ngIf="(item.status==='PENDING' && archive)">
                <i class="fa fa-edit me-3" (click)="getSelectedPnrDetails('ARCHIVE',i)"></i>

                <!-- <i class="fa fa-trash"></i> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
